import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  Icon,
} from 'semantic-ui-react';

import Selector from '../../selector';
import {
  ContainerAccordion,
  FloatRight,
  CustomAccordion,
  ContainerSelector,
} from './styles';

const CheckBoxAccordion = (props) => (
  <ContainerAccordion>
    <CustomAccordion styled>
      <Accordion.Title
        active={props.active}
        index={props.index}
        onClick={props.onClick}
      >
        <Icon name="dropdown" />
        {props.label}
        <FloatRight>{props.selectedItems}</FloatRight>
      </Accordion.Title>
      <Accordion.Content active={props.active}>
        <ContainerSelector>
          <Selector
            onChange={(e, obj) => props.onChange(e, obj)}
            values={props.values}
            checked={props.checked}
          />
        </ContainerSelector>
      </Accordion.Content>
    </CustomAccordion>
  </ContainerAccordion>
);

CheckBoxAccordion.propTypes = {
  active: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedItems: PropTypes.string,
  checked: PropTypes.shape(),
};

CheckBoxAccordion.defaultProps = {
  selectedItems: 'Any',
  checked: {},
};

export default CheckBoxAccordion;
